<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">

        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>

        <!-- Content Start -->
        <v-content>

          <!-- Page Header Start -->

          <!-- <page-header v-if="$route.meta.breadcrumb"></page-header> -->
          <div class="page-wrapper">
            <router-view></router-view>
          </div>   

          <!-- Page Header End -->

          <!-- App Footer Start -->

          <v-footer height="auto" class="white pa-3 app--footer">
            <v-spacer></v-spacer>
            <span class="caption">Made by <a href="https://codepanda.id" target="__blank">codepanda.id</a>, &copy; {{ new Date().getFullYear() }}</span>
            <v-spacer></v-spacer>
          </v-footer>

          <!-- App Footer End -->

        </v-content>
        <!-- Content End -->

        <!-- Go to top -->
        <app-fab></app-fab>

      </v-app>
    </template>

    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>

    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon> 
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>    
  </div>
</template>

<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import ThemeSettings from '@/components/ThemeSettings';
import AppEvents from  './event';

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
    ThemeSettings
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: '',
      color: '',
    }
  }),

  computed: {

  },

  created () {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
  },
  methods: {
    openThemeSettings () {
      this.$vuetify.goTo(0);
      this.rightDrawer = (!this.rightDrawer);
    }
  },

};
</script>


<style lang="stylus">
  .setting-fab 
    top:50%!important; 
    right:0;
    border-radius:0  
  .page-wrapper
    min-height:calc(100vh - 64px - 50px - 81px );  

  table.v-table thead th 
    font-size: 1em !important;
    font-weight: bold
    color: black   

  .alert
    color: #FF5252

</style>
